import { render, staticRenderFns } from "./JobsSelector.vue?vue&type=template&id=18d453b2&scoped=true&"
import script from "./JobsSelector.vue?vue&type=script&lang=js&"
export * from "./JobsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d453b2",
  null
  
)

export default component.exports